import React, { useEffect, useState } from 'react';
import LoadingSpinner from "../components/LoadingSpinner";
import { toast } from 'react-toastify';
import { IoMdSearch } from "react-icons/io";

const BuyTopUp = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true); 
  const [searchTerm, setSearchTerm] = useState('');
  const apiUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const token = localStorage.getItem('token');
        const vendorid = localStorage.getItem('vendorid');
        const response = await fetch(`${apiUrl}ESIM/Get_topup_plans?flag=2&vendorid=${vendorid}`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const data = await response.json();
        if (data.isSuccess) {
          setPlans(data.getpartner_plan);
        } else {
          console.error('API error:', data.message);
        }
      } catch (error) {
        console.error('Fetch error:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, []);

  const handletopup = (item) => {
    const partnerCode = localStorage.getItem("partnerCode");
    const guid = localStorage.getItem("guid");
    const iccid = localStorage.getItem("Iccid");
    const token = localStorage.getItem("token");

    const payload = {
      planid: item.p_id,  // Use p_id from the API response
      partnercode: partnerCode,
      iccid: iccid,
      guid: guid,
      cip: ""
    };

    fetch(`${apiUrl}ESIM/purchaseTopup_plan`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify(payload)
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.isSuccess) {
          toast.success(`${data.message}`);
        } else {
          toast.error(`Error: ${data.message}`);
        }
      })
      .catch((error) => {
        console.error("Error posting data:", error);
        toast.error(error.message || "An error occurred while posting data.");
      });
  };

  // Filter plans by searchTerm
  const filteredPlans = plans.filter(plan =>
    plan.planename.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="p-6 overflow-x-auto">
      <h1 className="text-2xl font-bold mb-4 text-center">Top-Up Plans</h1>

      <div className="mb-2 flex justify-end">
        <div className="relative p-3 rounded-full bg-[#117575]">
          <input
            type="text"
            placeholder="Search By Plan Name"
            className="w-full rounded-2xl bg-brand-gray h-8 pl-10"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <div className="absolute inset-y-0 left-0 flex items-center pl-3">
            <IoMdSearch size={20} className="text-gray-500" />
          </div>
        </div>
      </div>

      {loading ? (
        <LoadingSpinner />
      ) : (
        <table className="w-full bg-white border rounded-lg shadow">
          <thead className="py-2 px-4 mb-4">
            <tr className="border-b">
              <th className="text-center p-3 px-5">Plan ID</th>
              <th className="text-center p-3 px-5">Plan Name</th>
              <th className="text-center p-3 px-5">Price ($)</th>
              <th className="text-center p-3 px-5">Buy</th>
            </tr>
          </thead>
          <tbody>
            {filteredPlans.length === 0 ? (
              <tr>
                <td colSpan="4" className="text-center py-4 text-gray-500">
                  This plan does not support top-up
                </td>
              </tr>
            ) : (
              filteredPlans.map((plan) => (
                <tr key={plan.p_id} className="hover:bg-gray-50">
                  <td className="text-center p-3 px-5">{plan.p_id}</td>
                  <td className="text-center p-3 px-5">{plan.planename}</td>
                  <td className="text-center p-3 px-5">${plan.sellingcost}</td>
                  <td className="text-center">
                    <button
                      onClick={() => handletopup(plan)}
                      className="font-bold bg-[#144745] rounded-3xl p-4 text-white"
                    >
                      Top up
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default BuyTopUp;
